var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{ref:"fileProvider",attrs:{"rules":"selectRequired|image","name":"店舗画像"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-file-input',{attrs:{"accept":"image/*","error-messages":errors,"label":"店舗画像を選択","chips":"","value":_vm.value},on:{"change":function($event){return _vm.$emit('setImage', $event)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }